import styles from "./templatecard.module.css";
import { TableCell, TableRow } from "@mui/material";
import { Copy, Edit, Eye, EyeOff, MoreVertical, Trash2 } from "react-feather";
import { Dropdown } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const TemplateCard = ({ item, setSelectedItem, setArchiveModalOpen, setPublishModalOpen, setDeleteModalOpen, copyOfferTemplate }) => {
    const redirect = useHistory();
    const { user, isAuthenticated } = useAuth0();

    return (<TableRow>
        <TableCell className={`${styles.TableBodyText} ${styles.Head}`}>
            <div className={`${styles.ProfileImg}`}><img src="/static/img/offers.svg" alt="" /></div>
            {item?.title}
        </TableCell>
        <TableCell className={`${styles.TableBodyText}`} >
            {item?.is_archived === 0 && <span className={`${styles.StatusBadge} ${styles.Open}`}>Published</span>}
            {item?.is_archived === 1 && <span className={`${styles.StatusBadge} ${styles.Open}`}>Unpublished</span>}
        </TableCell>
        <TableCell className={`${styles.TableBodyText}`} >
            {item?.day_before} Days Before
        </TableCell>
        <TableCell className={`${styles.TableBodyText}`}>
            <div className={`${styles.ActionRight}`}>

                <Dropdown className={`${styles.ActionLeaseBUSec}`}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => { redirect.push('/communication/renewal-offers/view/' + item?.id); }}>
                            <Eye /> Preview
                        </Dropdown.Item>
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign-renewaltemplate:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => { redirect.push('/communication/renewal-offers/edit/' + item?.id); }}>
                            <Edit /> Edit
                        </Dropdown.Item>}
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign-renewaltemplate:create") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => copyOfferTemplate(item?.id)}>
                            <Copy /> Copy
                        </Dropdown.Item>}
                        {item?.is_archived === 0 && isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign-renewaltemplate:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setArchiveModalOpen(true); setSelectedItem(item); }}>
                            <EyeOff /> Unpublished
                        </Dropdown.Item>}
                        {item?.is_archived === 1 && isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign-renewaltemplate:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setPublishModalOpen(true); setSelectedItem(item); }}>
                            <Eye /> Published
                        </Dropdown.Item>}
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign-renewaltemplate:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectedItem(item); }}>
                            <Trash2 /> Delete
                        </Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </TableCell>
    </TableRow>)
}

export default TemplateCard;